module.exports = __webpack_public_path__ + "assets/img/config-fhir_1.a1263de4.svg";